"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsonpath_1 = tslib_1.__importDefault(require("jsonpath"));
function filterContentItems(data, contentMapping) {
    return (data && Array.isArray(data) ? data : []).slice(0, 5).map((itemData) => {
        if (!contentMapping.fields) {
            contentMapping.fields = [];
        }
        const newFields = [
            ...contentMapping.fields,
            {
                dateFormat: '',
                id: 'date',
                path: contentMapping.pathToDate,
                type: 'datetime',
            },
            {
                dateFormat: '',
                id: 'title',
                path: contentMapping.pathToTitle,
                type: 'text',
            },
        ];
        const ci = {};
        return Object.assign({}, newFields.reduce((acc, field) => {
            const getData = () => {
                try {
                    return jsonpath_1.default.query(itemData, field.path)[0];
                }
                catch (e) {
                    return '';
                }
            };
            acc[field.id] = Object.assign(Object.assign({}, field), { data: getData() });
            return acc;
        }, ci));
    });
}
exports.filterContentItems = filterContentItems;
//# sourceMappingURL=filterContentItems.js.map